import { SMTFoodEntryData } from '@equip.health/ui';
import { isEmpty } from 'lodash';

import { isBlobOrDataUrl } from '~/lib/util/file.util';

// SMTEntry is a global type from src/lib/types/SMT/index.d.ts

export enum SMTImageAction {
  ADD = 'ADD',
  REPLACE = 'REPLACE',
  NONE = 'NONE',
}

interface SMTImageActionResult {
  action: SMTImageAction;
  existingImageId?: string;
}

/**
 * Determines the image action needed for an SMT entry
 * @param data - The SMTFoodEntryData from the form
 * @param existingEntry - Optional existing entry data (for edit mode)
 * @returns The action type and any necessary metadata
 */
export const getSMTImageAction = (
  data: SMTFoodEntryData,
  existingEntry?: SMTEntry,
): SMTImageActionResult => {
  const hasImage = !isEmpty(data.image?.imageUrl);
  const existingImage = existingEntry?.images?.[0];

  if (!hasImage) {
    return { action: SMTImageAction.NONE };
  }

  const imageUrl = data.image.imageUrl;
  const isNewFile = typeof imageUrl === 'string' && isBlobOrDataUrl(imageUrl);

  if (isNewFile) {
    if (existingImage) {
      return {
        action: SMTImageAction.REPLACE,
        existingImageId: existingImage.id,
      };
    }
    return { action: SMTImageAction.ADD };
  }

  if (existingImage) {
    const urlMatches = existingImage.url === imageUrl;
    if (!urlMatches) {
      // URL changed, but it's not a new file (blob/data URL)
      // We can only upload/replace new files, so return NONE for existing URLs
      return { action: SMTImageAction.NONE };
    }
  }

  return { action: SMTImageAction.NONE };
};
